import { LanguageCode } from './language.model';
import { DocumentReference, Timestamp } from 'firebase/firestore';

export interface ContractCancellation {
  id?: string;
  userId: string;
  userEmail: string;
  student: DocumentReference;
  studentId: string;
  registration?: DocumentReference;
  registrationId?: string;
  cancellationType: CancellationType;
  status: CancellationStatus;
  reason?: string;
  effectiveDate?: Timestamp;
  requestedDate: Timestamp;
  processedDate?: Timestamp;
  processedBy?: {
    uid: string;
    email: string;
  };
  createdOn: Timestamp;
  updatedOn: Timestamp;
  language: LanguageCode;
  notes?: string;
}

export type CancellationType = 'registration' | 'contract';

export type CancellationStatus = 'requested' | 'cancelled';

export interface CancellationStatusConfig {
  label: string;
  color: string;
  description: string;
}

export const CancellationStatusConfigs: Record<
  CancellationStatus,
  CancellationStatusConfig
> = {
  requested: {
    label: $localize`:@@cancellation.status.requested:Beantragt`,
    color: '#f39c12',
    description: $localize`:@@cancellation.status.requested.description:Kündigung wurde beantragt und wird geprüft`,
  },
  cancelled: {
    label: $localize`:@@cancellation.status.cancelled:Gekündigt`,
    color: '#e74c3c',
    description: $localize`:@@cancellation.status.cancelled.description:Kündigung wurde durchgeführt`,
  },
};

export interface CancellationTypeConfig {
  label: string;
  description: string;
  icon: string;
}

export const CancellationTypeConfigs: Record<
  CancellationType,
  CancellationTypeConfig
> = {
  registration: {
    label: $localize`:@@cancellation.type.registration:Anmeldung`,
    description: $localize`:@@cancellation.type.registration.description:Kündigung einer Anmeldung`,
    icon: 'person_add',
  },
  contract: {
    label: $localize`:@@cancellation.type.contract:Vertrag`,
    description: $localize`:@@cancellation.type.contract.description:Kündigung eines aktiven Vertrags`,
    icon: 'description',
  },
};
